import { authApi } from "services/config/axiosConfig";

export interface AppConfig {
  teacher_application_paywall_enabled: boolean;
  email_verification_enabled: boolean;
  cv_upgrade_enabled: boolean;
  cv_upgrade_amount: number;
}

export const getAppConfig = async (): Promise<AppConfig> => {
  const response = await authApi.get("/api/v1/core/config");
  const data = response.data?.data;
  return {
    teacher_application_paywall_enabled: Boolean(data?.teacher_application_paywall_enabled),
    email_verification_enabled: Boolean(data?.email_verification_enabled),
    cv_upgrade_enabled: Boolean(data?.cv_upgrade_enabled),
    cv_upgrade_amount: Number(data?.cv_upgrade_amount) || 19.99,
  };
};
